
import { defineComponent, PropType } from "vue";
import WordBreakColumn from "@/components/shared/work-break-column/WordBreakColumn.vue";
import { usePagination } from "@/core/hooks/use-pagination";
import { VAT_TU_TABLE_COLUMN_WIDTHS } from "./vat-tu-table-column-widths";

export default defineComponent({
  name: "vat-tu-table",

  components: {
    WordBreakColumn,
  },

  props: {
    cellClassName: {
      type: [String, Function] as PropType<
        string | ((data: { row: unknown; column: unknown; rowIndex: number; columnIndex: number }) => string)
      >,
      default: undefined,
    },
    curPage: {
      type: Number,
      default: 1,
    },
    emptyText: {
      type: String,
      default: "Chưa có vật tư",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array as PropType<unknown[]>,
      default: () => [],
    },
    maxHeight: {
      type: [Number, String] as PropType<number | string>,
      default: undefined,
    },
    perPage: {
      type: Number,
      default: 0,
    },
    rowClassName: {
      type: [String, Function] as PropType<
        | string
        | ((data: { row: unknown; rowIndex: number }) => string)
      >,
      default: undefined,
    },
    spanMethod: {
      type: Function as PropType<
        (data: {
          row: unknown;
          column: unknown;
          rowIndex: number;
          columnIndex: number;
        }) => { rowspan: number; colspan: number } | void
      >,
      default: undefined,
    },
    showSummary: {
      type: Boolean,
      default: false,
    },
    summaryMethod: {
      type: Function as PropType<
        (data: {
          columns: unknown[];
          data: unknown[];
        }) => string[]
      >,
      default: undefined,
    },
    showSttId: {
      type: Boolean,
      default: true,
    },
    tableClass: {
      type: String,
      default: "",
    },
    tableId: {
      type: String,
      default: undefined,
    },
    tenMaxWidth: {
      type: [Number, String] as PropType<number | string | null>,
      default: null,
    },
    tenMinWidth: {
      type: [Number, String] as PropType<number | string | null>,
      default: null,
    },
    tenWidth: {
      type: [Number, String] as PropType<number | string | null>,
      default: null,
    },
    usePaginationIndex: {
      type: Boolean,
      default: false,
    },
  },

  setup() {
    const { indexCal } = usePagination();

    return {
      columnWidths: VAT_TU_TABLE_COLUMN_WIDTHS,
      indexCal,
    };
  },

  methods: {
    isFooterRow(row: unknown) {
      return Boolean(
        row &&
          typeof row === "object" &&
          "_footerType" in row &&
          (row as { _footerType?: string })._footerType
      );
    },

    sttDisplay(index: number) {
      if (this.usePaginationIndex && this.perPage > 0) {
        return this.indexCal(index, this.curPage, this.perPage);
      }

      return index + 1;
    },
  },
});
